import React from 'react';
import { BUSINESS, ABOUT, fullAddress } from './businessInfo';

// About us. Written for a customer, and for the payment gateway reviewer who
// wants to see a real business behind the checkout: what it sells, who runs it,
// and where it operates from.
//
// Replace the copy freely — but keep the business details at the foot, because
// those are what the reviewer looks for. Each of those rows only appears once the
// value behind it exists in businessInfo.js, so the page never shows a guess.
//
// One <section> per heading: on a phone they are only spacing, and on a computer
// they become the cards of a grid (see _infopages.scss).

const AboutUs = () => (
    <div className="so-infopage">
        <section className="so-infopage__section">
            <h3>Welcome to {BUSINESS.fullName}</h3>
            <p className="so-infopage__meta">{BUSINESS.tagline}</p>
            <p>
                {BUSINESS.fullName} cooks fresh through the day from our kitchen in{' '}
                {BUSINESS.city}, {BUSINESS.district}.
            </p>
            <p>
                We cook to order rather than in advance, which is why our kitchen is
                happiest when it knows what is coming. That is the idea behind special
                orders: tell us the dishes and the date, and the kitchen plans around it.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>Our story</h3>
            <p>{ABOUT.story}</p>
        </section>

        <section className="so-infopage__section">
            <h3>What we stand for</h3>
            <ul className="so-infopage__facts">
                {ABOUT.values.map((item) => (
                    <li key={item.title}>
                        <span>{item.title}</span>
                        <strong>{item.detail}</strong>
                    </li>
                ))}
            </ul>
        </section>

        <section className="so-infopage__section">
            <h3>Special orders</h3>
            <p>
                Special orders let you reserve dishes for a date ahead, for a family
                lunch, an office order or a function. You choose the items and the date,
                pay online to confirm, and pick the order up or have it delivered. Larger
                orders get planned into the day's cooking, so the food is ready at the
                time you asked for and not reheated.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>Food quality and hygiene</h3>
            <p>
                We cook in our own kitchen with ingredients bought for the day. Our staff
                follow the hygiene practices expected of a licensed food business. If a
                dish ever reaches you in a state you are not happy with, contact us the
                same day — that is a conversation we would rather have than not.
            </p>
        </section>

        <section className="so-infopage__section">
            <h3>Business details</h3>
            <ul className="so-infopage__facts">
                {BUSINESS.legalName && (
                    <li>
                        <span>Legal name</span>
                        <strong>{BUSINESS.legalName}</strong>
                    </li>
                )}
                <li>
                    <span>Address</span>
                    <strong>{fullAddress()}</strong>
                </li>
                {BUSINESS.phone && (
                    <li>
                        <span>Phone</span>
                        <strong>{BUSINESS.phone}</strong>
                    </li>
                )}
                {BUSINESS.hours && (
                    <li>
                        <span>Hours</span>
                        <strong>{BUSINESS.hours}</strong>
                    </li>
                )}
                {BUSINESS.fssai && (
                    <li>
                        <span>FSSAI licence</span>
                        <strong>{BUSINESS.fssai}</strong>
                    </li>
                )}
                {BUSINESS.gstin && (
                    <li>
                        <span>GSTIN</span>
                        <strong>{BUSINESS.gstin}</strong>
                    </li>
                )}
            </ul>
        </section>

        <p className="so-infopage__note">
            All prices on this site are in Indian Rupees ({BUSINESS.currencySymbol}) and
            include applicable taxes unless stated otherwise at checkout.
        </p>
    </div>
);

export default AboutUs;
